import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import HostHome from "@/pages/HostHome";
import SchoolSite from "@/pages/SchoolSite";
import AdminHome from "@/pages/AdminHome";
import AdminDashboard from "@/pages/AdminDashboard";
import Settings from "@/pages/Settings";
import SuperDashboard from "@/pages/SuperDashboard";
import AdminGuard from "@/components/admin/AdminGuard";
import SchoolScope from "@/components/admin/SchoolScope";

const AuthPage = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-brand-soft dots-bg px-4 py-10">{children}</div>
);

const PathSite = () => <SchoolSite slug={useParams().slug} />;
const scoped = (page) => <AdminGuard><SchoolScope>{page}</SchoolScope></AdminGuard>;

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Routes>
          <Route path="/" element={<HostHome />} />
          <Route path="/s/:slug" element={<PathSite />} />
          <Route path="/admin" element={<AdminGuard><AdminHome /></AdminGuard>} />
          <Route path="/admin/schools/:schoolId" element={scoped(<AdminDashboard />)} />
          <Route path="/admin/schools/:schoolId/settings" element={scoped(<Settings />)} />
          <Route path="/super" element={<AdminGuard superOnly><SuperDashboard /></AdminGuard>} />
          <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/admin" /></AuthPage>} />
          <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/admin" /></AuthPage>} />
        </Routes>
      </ClerkAuthProvider>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
